import React, {Component} from 'react'
import $ from 'jquery'

import Registry from '../../../registry/index';

class CodeInputForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formData: {
                code: ''
            },
            error: '',
            inactiveEmail: props.inactiveEmail ? props.inactiveEmail : window.__currentUser ?  window.__currentUser.email : '',
            activationOnly: !!props.activationOnly
        };

        this._onError = this._onError.bind(this);
        this._onSuccess = this._onSuccess.bind(this);
    }

    componentDidMount() {
        $('#send-sms').click(() => this.props.switchTab(5));
    }

    sendData(e) {
        let siteInterface = Registry.get('siteInterface');
        siteInterface.activateByCode(this.state.formData).then(this._onSuccess).catch(this._onError);
        e.preventDefault();
    }

    _onSuccess(_response) {
        let siteInterface = Registry.get('siteInterface');
        let chatInterface = Registry.get('chatInterface');

        if(chatInterface.isLoggedIn()) chatInterface.logout();

        chatInterface.setAuthParams({
            current_user: _response.data.user
        });

        this.setState({
            formData: {
                code: '',
            },
            error: ''
        });

        window.setTimeout(function() {
            chatInterface.login(
                () => siteInterface.refreshParentWindowUser()
            );
        }, 300);

        this.props.close();
    }

    _onError(exception) {
        this.setState({error: exception.message});
    }

    handleChange (event) {
        this.setState({
            formData: {
                ...this.state.formData,
                [event.target.name]: event.target.value
            }
        });
    }

    render() {
        let lang = Registry.get('locale');

        let { 
            error,
            formData,
            inactiveEmail,
            activationOnly
        } = this.state;

        let disabledEnter = !formData.code ? 'disabled' : '';

        return (
            <div className="codeinput-form content">
                {!activationOnly ? <a href="#" className="tab-back" onClick={() => this.props.switchTab(1)}>{lang.registration_back}</a> : null}
                {!activationOnly ? <p className="text" dangerouslySetInnerHTML={{__html: lang.enter_activation_code_text(inactiveEmail)}} /> : <p className="text sms-activation">{lang.enter_sms_activation_code}</p>}
                <form onSubmit={e => this.sendData(e)}>
                    <input
                        name="code"
                        type="text"
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        placeholder={lang.code}
                        value={formData.code}
                        onChange={e => this.handleChange(e)}
                    />
                    <button
                        className="popup-button primary"
                        disabled={disabledEnter}
                        onClick={e => this.sendData(e)}
                    >{lang.send}</button>
                </form>
                <p className="error" dangerouslySetInnerHTML={{__html: error}} />
                {!activationOnly ? <p className="text-min" dangerouslySetInnerHTML={{__html: lang.enter_activation_code_text_min}} /> : null}
            </div>
        )
    }
}

export default CodeInputForm;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/AnonymousLoginPopup/CodeInputForm.js